import React, { useState } from 'react';
import { Modal, Button, Row, Col, Form, Spinner } from 'react-bootstrap';
import attachments from "assets/img/icons/Attach ment-01.svg"
import { toast } from "react-toastify";
import { UpdateMessageNotesAction } from '../../../../Redux/Inbound/actions';
import { useSelector, useDispatch } from 'react-redux';


const AddNote = ({ show, handleClose, data }) => {
    const dispatch = useDispatch();
    const [note, setNote] = useState([]);
    const [validated, setValidated] = useState(false);
    const [showSpinner, setSpinner] = useState(false);


    const toastConfig = {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 2500,
    };

    const handleSendNote = async (event) => {
        const form = event.currentTarget;
        setSpinner(true)
        event.preventDefault();
        if (form.checkValidity() === false) {
            event.stopPropagation();
            setValidated(true);
            setSpinner(false)
        }
        else {
            data?.notes.push({ text: note })
            const res = await UpdateMessageNotesAction(dispatch, data.id, data)
            if (res.success) {
                toast.success("Note Submitted", toastConfig);
                setNote('')
                setSpinner(false)
                handleClose();
            }
        }
    };

    return (
        <Modal show={show} onHide={handleClose} size='md' centered={true} >
            <Modal.Body>
                <p className='adnote-font'>Add a note</p>
                <Form noValidate validated={validated} onSubmit={handleSendNote}>
                    <Form.Group controlId="exampleForm.ControlTextarea1">
                        <Form.Control
                            as="textarea"
                            value={note}
                            rows={15}
                            onChange={(e) => setNote(e.target.value)}
                            placeholder='Enter your notes'
                            className='p-2 mb-5'
                            required
                        />
                    </Form.Group>
                    <Row>
                        <Col className='d-flex align-items-center'>
                            {/* <h5 className='custom-h5'>@</h5> */}
                            {/* <img src={attachments} width={20} className='custom-cursor-class' /> */}
                        </Col>
                        <Col>
                            {showSpinner ? "" :
                                <Button variant="secondary" onClick={handleClose} className='custom-button shadow'>
                                    Cancel
                                </Button>}
                            {!showSpinner ? <Button variant="secondary" type='submit' className='custom-button shadow'>
                                Send
                            </Button> :
                                <Button variant="primary" className='custom-button' disabled>
                                    <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" variant='light' className='mr-2' />
                                    Loading...
                                </Button>}

                        </Col>
                    </Row>
                </Form>
            </Modal.Body>



        </Modal>
    );
};

export default AddNote;
